histories-created
  span.label.label-sm(class="{opts.label-klass ? opts.label-klass : 'label-success'}" style="{opts.labelStyle}") {opts.locale.labels[opts.scope]}{ opts.label }
  shared-raw.value(content="{opts.getter(this.opts.json[opts.scope])}")
  script(type="typescript").
    this.mixin('histories.base');
